<template>
  <div class="table" style="padding:10px">
    <a-row type="flex" align="middle" justify="space-between" style="margin-bottom:10px" v-if="layout.layoutType">
      <h4>
        <a-space> 配方原料
          <!-- <a-button type='link' size="small" @click="toggleRawVisible" style="font-size:12px">批量添加</a-button> -->
        </a-space>
      </h4>
      <a-space class="icon-bar">
        <!-- showImportProject -->
        <a-tooltip>
          <template slot="title">导入产品库</template>
          <a-button type="link" @click="showImportProject">
            <img width="20" :src="importProduct" alt="导入产品库" />
          </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title">添加原料</template>
          <a-button type="link" @click="toggleRawVisible">
            <img :src="addImg" alt="添加原料" />
          </a-button>
        </a-tooltip>
        <a-tooltip>
            <template slot="title">移出原料</template>
            <a-badge :count="rawRows.length">
              <!-- <a-button icon="delete" type="link" :disabled="rawRows.length == 0" @click="removeRaw" /> -->
              <a-button type="link" :disabled='rawRows.length === 0' @click="removeRaw">
                <img :src="deleteImg" alt="移出原料" />
              </a-button>
            </a-badge>
          </a-tooltip>
        <slot />
      </a-space>
    </a-row>
    <a-row class="list-block" v-if="layout.layoutType">
      <!-- <a-col class="list-block-side" :span="leftSpan" :style="{height:`${height}px`}"  v-if="layout.showSider" >
        <raw-side ref="allRawList" @ok="addSignleRaw"/>
      </a-col> -->
      <!-- <a-col :span="rightSpan"> -->
      <a-col>
        <resize-table
          :scroll="{ x:400, y: height }"
          bordered
          :columns="rawColumnsValue"
          :loading="rawListLoading"
          tableName="rawTableColumns"
          :data-source="list.records"
          :row-selection="{selectedRowKeys,onSelect, getCheckboxProps, onSelectAll}"
          :row-key="record => record.id"
          :pagination="false"
          :rowClassName="rowClassname"
        >
          <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 原料名称</span>
          <a-tooltip size="small" slot="rawName" slot-scope="text,item">
            <a-row type="flex" align="middle" justify="space-between" v-if="item.isRawDelete == 1">
              <span style="padding:2px 4px;flex:1" class="nameStyle">
                <a-icon type="profile" v-if="item.productType != 1" />
                {{overseasFlag == '1' ? (item.aliasName || text) : text}}
              </span>
              <a-button v-if="item.isExtraProRaw != '1'" type="link" size="small" icon="delete"  @click="viewRaw(item)"/>
            </a-row>

            <a-row type="flex" align="middle" justify="space-between" v-if="item.isRawDelete != 1 && item.isExtraProRaw == '1'">
              <span style="padding:2px 4px;flex:1" class="nameStyle">
                <a-icon type="profile" v-if="item.productType != 1" />
                {{overseasFlag == '1' ? (item.aliasName || text) : text}}
              </span>
              <a-button type="link" size="small" icon="plus"  @click="viewRaw(item)"/>
            </a-row>

            <a v-if="item.isExtraProRaw != '1' && item.isRawDelete != 1" @click="viewRaw(item)" class="nameStyle">
              <a-icon type="profile" v-if="item.productType != 1" />
              {{overseasFlag == '1' ? (item.aliasName || text) : text}}
            </a>
            <template slot="title">{{overseasFlag == '1' ? (item.aliasName || text) : text}}</template>
          </a-tooltip>

          <template slot="productRawPercentage" slot-scope="text,record">
            {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 3)}}
          </template>
          <template v-for="(col,i) in ['price','minValue', 'maxValue']" slot-scope="text, record" :slot="col">
            <span v-if="record.isRawDelete==1 || record.isExtraProRaw == 1" :key="col">
              {{text|numberFixed(3)}}
            </span>
            <cell-editor
              v-else
              :background="true"
              :key="i"
              :item="record"
              :len="3"
              :name="col"
              @blur="target => itemUpdate(target,record.id,record,col)"
              :text="text"
              :actions="update" />
          </template>
          <template
            v-for="(item,index) in ['percentage','maxApply', 'minApply','uasge', 'maxShadowPrice','minShadowPrice','cost', 'minLimitValue','maxLimitValue']"
            :slot="item"
            slot-scope="text"
          >
            <span :key="item" v-if="item === 'cost'">{{text ? text.toFixed(3) : ''}}</span>
            <span v-else :key="item + index">{{text || text === 0 ? text.toFixed(3) : ''}}</span>
          </template>
          <template slot="footer">
            <a-alert v-if="this.alertFlag && this.selectedRows.length > 0" type="info" show-icon closable
                     @close="cancelOnly" class="inline-alert">
              <template #message>
                <a-row type="flex" justify="space-between">
                  <a-col>
                <span>
                  选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                  <span class="alert-info">
                    成本合计<span style="color: green">{{ totalCost.toFixed(3) }}</span>(元/吨)，
                    用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                  </span>
                </span>
                  </a-col>
                  <a-col>
                    <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
                  </a-col>
                </a-row>
              </template>
            </a-alert>
          </template>
        </resize-table>
      </a-col>
    </a-row>
    <resize-table
      v-else
      :scroll="{ x:500, y: height - 20 }"
      bordered
      tableName="rawTableColumns"
      :columns="rawColumnsValue"
      :loading="rawListLoading"
      :data-source="list.records"
      :row-selection="{selectedRowKeys, onSelect, getCheckboxProps,onSelectAll}"
      :row-key="record => record.id"
      :pagination="false"
      :rowClassName="rowClassname"
    >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 原料名称</span>
      <template slot="rawName" slot-scope="text,item">
        <a-tooltip size="small">
          <a-row type="flex" align="middle" justify="space-between" v-if="item.isRawDelete == 1">
            <span style="padding:2px 4px;flex:1" class="nameStyle">
              <a-icon type="profile" v-if="item.productType != 1" />
              {{overseasFlag == '1' ? (item.aliasName || text) : text}}
            </span>
            <a-button v-if="item.isExtraProRaw != '1'" type="link" size="small" icon="delete"  @click="viewRaw(item)"/>
          </a-row>
          <a-row type="flex" align="middle" justify="space-between" v-if="item.isRawDelete != 1 && item.isExtraProRaw == '1'">
            <span style="padding:2px 4px;flex:1" class="nameStyle">
              <a-icon type="profile" v-if="item.productType != 1" />
              {{overseasFlag == '1' ? (item.aliasName || text) : text}}
            </span>
            <a-button type="link" size="small" icon="plus"  @click="viewRaw(item)"/>
          </a-row>
          <a v-if="item.isExtraProRaw != '1' && item.isRawDelete != 1" @click="viewRaw(item)" class="nameStyle">
            <a-icon type="profile" v-if="item.productType != 1" />
            {{overseasFlag == '1' ? (item.aliasName || text) : text}}</a>
          <template slot="title">{{overseasFlag == '1' ? (item.aliasName || text) : text}}</template>
        </a-tooltip>
      </template>
      <template slot="productRawPercentage" slot-scope="text,record">
        {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 3)}}
      </template>
      <template v-for="(col,i) in ['price','minValue', 'maxValue']" slot-scope="text, record" :slot="col">
        <span v-if="record.isRawDelete==1 || record.isExtraProRaw == 1" :key="col">
        {{text ? text.toFixed(3) : ''}}
        </span>
        <cell-editor
          v-else
          :background="true"
          :key="i"
          :item="record"
          :len="3"
          :name="col"
          @click="saveRow(record)"
          @blur="target => itemUpdate(target,record.id,record,col)"
          :text="text"
          :actions="update" />
      </template>
      <template
        v-for="(item,index) in ['percentage','maxApply', 'minApply','uasge', 'maxShadowPrice','minShadowPrice','cost', 'minLimitValue','maxLimitValue']"
        :slot="item"
        slot-scope="text"
      >
        <span :key="item" v-if="item === 'cost'">{{text ? text.toFixed(3) : ''}}</span>
        <span v-else :key="item + index">{{text || text === 0 ? text.toFixed(3) : ''}}</span>
      </template>
      <template slot="footer">
        <a-alert v-if="this.alertFlag && this.selectedRows.length > 0" type="info" show-icon closable
                 @close="cancelOnly" class="inline-alert">
          <template #message>
            <a-row type="flex" justify="space-between">
              <a-col>
                <span>
                  选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                  <span class="alert-info">
                    成本合计<span style="color: green">{{ totalCost.toFixed(3) }}</span>(元/吨)，
                    用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                  </span>
                </span>
              </a-col>
              <a-col>
                <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
              </a-col>
            </a-row>
          </template>
        </a-alert>
      </template>
    </resize-table>
    <raw-model :hidden="rawVisible" @cancel="toggleRawVisible" @ok="addRaw" />
    <nutrient-modal ref="nutrientModel" @refresh="refresh" @refreshNutrition='refreshNutrition' />
    <calculation-result-modal @ok="confirmResult" />
    <import-project-list :hidden="importProjectVisible" @close="closeImportProject" />
  </div>
</template>

<script>
// 用量（%）= 最大值和极上限时，最大值、极上限显示为红色；用量（%）= 最小值和极下限时，最小值、极下限显示为绿色
import {nhfMixins} from '../../untils'
import CalculationResultModal from '../modal/CalculationResultModal.vue'
import NutrientModal from '../modal/NutrientModal.vue'
import RawModel from '../modal/RawModel.vue'
import ImportProjectList from '../modal/ImportProjectList.vue'

// import RawSide from '../modal/RawSide.vue'
import CellEditor from './CellEditor.vue'
import rawColumns from './rawColumns'
import deleteImg from '@/assets/images/icon/delete.png'
import addImg from '@/assets/images/icon/add.png'
import importProduct from '@/assets/images/icon/importProduct.png'
export default {
  mixins:[nhfMixins],
  props: ['customId','showAdd'],
  components:{RawModel, CellEditor, ImportProjectList,
  // RawSide,
   CalculationResultModal, NutrientModal},
  data(){
    return{
      deleteImg,addImg,importProduct, // icon
      importProjectVisible: false,
      filled: true,
      itemVisible:false,
      rawVisible:false,
      rawListLoading:false,
      filterData:{},
      currentValue:null,
      priceValues:'',
      list:{
        records:[]
      },
      cacheData:[],
      rawColumns,
      // 原料名称、代码、价格、用量%、最小值、最大值、用量(批次量)、影子价格下限、影子价格上限、单位成本、适用下限、适用上限、极下限、极上限；
      priceVal:['privateContractPrice','privatePredictionPrice','privateStockPrice','privateMarketPrice'],
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      rowData: {}
    }
  },
  mounted(){
    const {id} = this.$route.query
    this.formulaId = id
  },
  computed:{
    leftSpan(){
      const {showSider} = this.layout
      return showSider ? 4 :24
    },
    rightSpan(){
      const {showSider} = this.layout
      return showSider ? 20 : 24
    },
    removeDisable(){
      return this.selectedRowKeys.length === 0
    },
    priceValue(){
      let pr = this.priceOption[this.detail.priceSource - 1]
      return pr ? pr.label : null
    },
    listData(){
      let list = []
      // let rawIds = this.selectedRowKeys.map(item => {
      //   return this.selectedRows.filter(i=>i.id === item)[0].rawId
      // })
      // return {
      //   // rawIds:this.selectedRows.map(item => item.id).join(),
      //   ids:this.rawRows.map(i=>i.id).join(),
      //   rawIds:this.rawRows.map(i=>i.rawId).join(),
      //   formulaId:this.formulaId
      // }
      this.rawRows.forEach(el => {
        list.push({
          formulaId: this.formulaId,
          id: el.id,
          type: el.productType
        })
      })
      return list
    },
  },

  watch:{
    selectedRows:{
      handler(rawRows){
        this.$emit('select',rawRows)
        if(rawRows[0]){
          this.setState({rawSelect:rawRows[0],rawRows})
        }else{
          this.setState({rawSelect:{},rawRows: []})
        }
      },
      deep: true
    },
    async rawTypeSelect(){
      this.filterList()
    }
  },

  methods:{
    closeImportProject(type){
      if(type) this.getList()
      this.importProjectVisible = false
    },
    showImportProject(){
      this.importProjectVisible = true
    },
    refreshNutrition(){
      this.$emit('refreshNutrition');
    },
    saveRow(record){
      this.rowData = {...record}
    },
    changeColumns2(){
      let rawColumnsValue = [...this.rawColumnsValue]
      if(this.filled){
        rawColumnsValue[0].fixed = 'left'
      }else{
        delete rawColumnsValue[0].fixed
      }
      this.setState({rawColumnsValue})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns2()
      e = e || window.event;
      if(e.stopPropagation) { //W3C阻止冒泡方法
          e.stopPropagation();
      } else {
          e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    getCheckboxProps(record){
      return ({
        props: {
          disabled: (record.isRawDelete == 1 || record.isExtraProRaw == 1) || (!this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length > this.maxLen),
        }
      })
    },

    confirmResult(changeList,otherList){
      this.$refs['nutrientModel'].setResult(changeList,otherList)
    },

    getResult(rawResult){
      this.rawResult = rawResult
      this.toggleResultVisible()
    },

    viewRaw(rawSelect){
      if(rawSelect.isRawDelete == 1){
        // this.$message.warn('原料已经删除')
        this.removeRaw(rawSelect)
      }else {
        if(rawSelect.isExtraProRaw == 1){
          this.addRaw([rawSelect],true)
          this.$emit('refresh',false,false)
        }else{
          this.setState({rawSelect})
          this.toggleVisible('raw')
        }
      }
    },
    refresh(){
      this.$emit('refresh',false,false)
    },

    rowClassname(record){
      return record.isRawDelete == 1 || record.isExtraProRaw == 1 ? 'selectGary' : (record.percentage === 0 ? 'selectRows' : '')
    },

    cleanSelect(){
      this.selectedRowKeys=[]
      this.selectedRows=[]
    },

    addSignleRaw(){
      this.getList()
    },

    async addRaw(row,isSider){
      this.rawListLoading = true
      isSider || this.toggleRawVisible()
      await this.fetchPost({
        actions:this.saveCustomFormulaRawIds,
        loading:'addLoading',
        data:{
          rawIds:row.map(i=>i.rawId).join(), // item.rawId,
          id:this.$route.query.id,
        }
      })
      this.getList()
    },

    toggleRawVisible(){
      this.rawVisible = !this.rawVisible
    },

    itemChange(value, id, column) {
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      if (target) {
        target[column] = value
        this.list.records = newData
      }
    },

    eidtorItem(id){
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },

    itemUpdate(item,id){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(item => id === item.id)[0]
      const targetCache = newCacheData.filter(item => id === item.id)[0]
      if (targets && targetCache) {
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
        this.calculatePrice()
      }
    },
    computerTotal(data){
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          //如果item 和 data id 相等是同一条数据，将百分比较和价格覆盖
          if(item.rawId === data.rawId){
            item.percentage = data.percentage
            item.price = data.price
          }
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
      }
    },
    async update(arg,type,name){
      let datas = JSON.parse(JSON.stringify(arg))
      delete datas.rawName
      const {price,rawId} = datas
      const isPrice = name == 'price'
      const data = isPrice ? {price,priceSource:this.detail.priceSource,rawId,factoryId:this.factoryId,id: arg.id} : datas
      let updateFeild = 'updateCustFactoryStaffRawPrice'
      if(arg.productType != 1) updateFeild = 'updateCustomFormulaRawProPrice'
      data.customId = this.detail.customId
      await this.fetchPost({
        actions: isPrice ? this[updateFeild] : this.updateCustomFormulaRaw,
        data,
        showMessage:false
      })
      this.$emit('refresh',false,false)
      this.computerTotal(datas);
      return {}
    },

    async resetRaw(){
      if(this.selectedRows.length){
        this.$confirm({
          title: '提示',
          content: '确认将选中的原料恢复至默认值吗？',
          okText: '继续',
          cancelText: '取消',
          onOk: async () =>{
            await this.fetchPost({
              actions:this.resetFormulaRawIds,
              data:this.listData
            })
            this.getList()
          },
          onCancel(){},
        })
      } else {
        this.$message.warn('请选择需要更新的原料')
      }
    },

    async removeRaw(item){
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料移出？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () => this.removeRawAction(item),
        onCancel(){},
      })
    },

    async removeRawAction(item){

      let data = {}
      if(item && item.id){
        data.customFormulaRawDelList = [{id: item.id,type: item.productType,formulaId: this.formulaId}]
      }else{
        data.customFormulaRawDelList = this.listData
      }
      await this.fetchPost({
        actions:this.removeCustomFormulaRaws,
        data
        // data: item && item.id ? { formulaId:this.formulaId,ids:item.id,rawIds:item.rawId} : this.listData
      })
      this.$emit('refresh',false,false)
      this.getList()
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs['allRawList'] && this.$refs['allRawList'].getList()
    },

    async getList(){
      this.list.records = []
      // const res = await this.fetchGet({
      const res = await this.fetchGet({
        // isList:true,
        loading:'rawListLoading',
        name:'records',
        actions:this.getCustomFormulaRaw,
        showMessage: false,
        data:{
          formulaId:this.formulaId,
          // factoryId:this.factoryId,
          // ...arg,
          // current: 1,
          // size:1000
        }
      })
      // if(res && res.data && res.data.records){
      if(res && res.data){
        this.cleanSelect()
        // this.cacheData = JSON.parse(JSON.stringify(res.data.records))
        this.cacheData = JSON.parse(JSON.stringify(res.data))
        this.calculatePrice()
      }
      this.filterList()
      // if(this.rawTypeSelect !== 'all'){
      //   const {data} = res
      //   if(data?.records){
      //     if(this.rawTypeSelect == 1)  this.list.records =  data.records.filter(i => i.percentage > 0)
      //     if(this.rawTypeSelect == 2)  this.list.records =  data.records.filter(i => i.percentage == 0)
      //   }
      // }
      return res
    },
    calculatePrice(){
      let count = 0
      this.cacheData.forEach(el => {
        count += (el.price || 0) * (el.percentage || 0) / 100
      })
      this.$emit('countPrice',count.toFixed(3))
    },
    filterList(){
      const list = JSON.parse(JSON.stringify(this.cacheData))
      if(list && list.length){
        if(this.rawTypeSelect == 0) this.list.records = JSON.parse(JSON.stringify(this.cacheData))
        if(this.rawTypeSelect == 1) this.list.records =  list.filter(i => i.percentage > 0)
        if(this.rawTypeSelect == 2) this.list.records =  list.filter(i => i.percentage == 0)
      }
    },
    cancelOnly() {
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
    cancelSelection() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
  }

}
</script>

<style lang="scss" scoped>
::v-deep .ant-table.ant-table-bordered .ant-table-footer {
  padding: 0;
}
</style>

<style lang="scss">
  .icon-bar ::v-deep .anticon{
    font-size:16px !important;
  }
  .selectRows{
    background-color: rgba(255, 206, 163, 0.1) !important;
    background-color:#fff9e5 !important;
  }
  .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
  h3{
    margin: 0;
  }
  .red{color: red;}
  .green{color: green;}
</style>
